export enum adminCompanyListTypes {
    FETCH_ADMIN_COMPANY_LIST_REQUEST = "FETCH_ADMIN_COMPANY_LIST_REQUEST",
    FETCH_ADMIN_COMPANY_LIST_SUCCESS = "FETCH_ADMIN_COMPANY_LIST_SUCCESS",
    FETCH_ADMIN_COMPANY_LIST_FAILURE = "FETCH_ADMIN_COMPANY_LIST_FAILURE",
  }